import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    comboProductList,
    initialState,
} from 'app/core/models/slice/combo/comboProductList'
import { isObject, isArray } from 'lodash'

const slice = createSlice({
    name: 'comboProductList',
    initialState,
    reducers: {
        clearComboProductList: (state) => {
            Object.keys(initialState).map((key1) => {
                if (isObject(state[key1])) {
                    state[key1] = {}
                } else if (isArray(state[key1])) {
                    state[key1] = []
                } else {
                    state[key1] = ''
                }
            })
        },
        setComboProductList: (
            state,
            action: PayloadAction<comboProductList>
        ) => {
            state = { ...action.payload }
        },

        setComboProductListObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState).map((key1) => {
                    if (
                        key1 === key &&
                        action.payload[key] !== '' &&
                        action.payload[key] !== undefined &&
                        action.payload[key] !== null
                    ) {
                        state[key] = action.payload[key]
                    }
                })
            })
        },
    },
})

export const {
    clearComboProductList,
    setComboProductList,
    setComboProductListObArr,
} = slice.actions

export default slice.reducer
